import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Container from 'common/components/UI/Container';
import { PiPawPrintFill } from 'react-icons/pi';

const HeaderWrapper = styled.header`
  width: 100%;
  overflow: hidden;
  padding: ${({ $compact }) => ($compact ? '36px 0 28px' : '100px 0 48px')};
  margin-top: ${({ $compact }) => ($compact ? '0' : '70px')};
  position: relative;
  background: ${themeGet('colors.surface')};
  border-bottom: 1px solid ${themeGet('colors.borderColor')};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: ${themeGet('colors.secondary')};
  }

  @media (max-width: 768px) {
    padding: ${({ $compact }) => ($compact ? '28px 0 20px' : '76px 0 36px')};
  }
`;

const HeaderContent = styled.div`
  text-align: center;
  color: ${themeGet('colors.headingColor')};
  position: relative;
  z-index: 2;

  .eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding: 8px 14px;
    color: ${themeGet('colors.headingColor')};
    background: ${themeGet('colors.secondary')};
    border-radius: 999px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  h1 {
    max-width: 820px;
    margin: 0 auto 14px;
    color: ${themeGet('colors.headingColor')};
    font-size: clamp(32px, 5vw, 52px);
    font-weight: 800;
    line-height: 1.15;
    letter-spacing: -0.04em;

    @media (max-width: 768px) {
      font-size: ${({ $compact }) => ($compact ? '28px' : '32px')};
    }
  }

  p {
    max-width: 680px;
    margin: 0 auto;
    color: ${themeGet('colors.textColorAlt')};
    font-size: 17px;
    line-height: 1.7;

    @media (max-width: 768px) {
      font-size: 15px;
    }
  }
`;

const PageHeader = ({
  title,
  description,
  eyebrow = 'Furbuz',
  compact = false,
}) => {
  return (
    <HeaderWrapper $compact={compact}>
      <Container>
        <HeaderContent $compact={compact}>
          <span className="eyebrow">
            <PiPawPrintFill aria-hidden="true" />
            {eyebrow}
          </span>
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </HeaderContent>
      </Container>
    </HeaderWrapper>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  eyebrow: PropTypes.string,
  compact: PropTypes.bool,
};

export default PageHeader;
